import { createSelector } from 'reselect';
import ReceptacleEventIrregularitiesColumns from '../../containers/ReceptacleEventIrregularitiesColumns';
import ReportDefinitions from '../../../../../../common/config/ReportDefinitions';

export const getGeneratedOnDateTime =
  state => state.reporting.RECEPTACLE_EVENT_IRREGULARITIES.metadata.generatedOnDateTime;

export const getIsLoading =
  state => state.reporting.RECEPTACLE_EVENT_IRREGULARITIES.isLoading;

export const getData =
  ReportDefinitions.RECEPTACLE_EVENT_IRREGULARITIES.getDataFunction();

export const getColumns =
  createSelector(getData, ReceptacleEventIrregularitiesColumns);
